class Map

	config:
		apiKey:'AIzaSyBW_sQF0Udjy3Dgp1Wlp2s9xcLeCefbbow'
		coord:[48.8566, 2.3522]
		zoom:6
		mapStyle:[ { "featureType": "all", "elementType": "labels.text.fill", "stylers": [ { "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 } ] }, { "featureType": "all", "elementType": "labels.text.stroke", "stylers": [ { "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 } ] }, { "featureType": "all", "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [ { "color": "#fefefe" }, { "lightness": 20 } ] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [ { "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 } ] }, { "featureType": "administrative.locality", "elementType": "labels.text.fill", "stylers": [ { "color": "#eda093" }, { "visibility": "on" } ] }, { "featureType": "administrative.locality", "elementType": "labels.text.stroke", "stylers": [ { "color": "#ffffff" } ] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [ { "color": "#f5f5f5" }, { "lightness": 20 } ] }, { "featureType": "landscape.natural", "elementType": "geometry.fill", "stylers": [ { "color": "#b9e4ba" } ] }, { "featureType": "poi", "elementType": "geometry", "stylers": [ { "color": "#f5f5f5" }, { "lightness": 21 } ] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [ { "color": "#dedede" }, { "lightness": 21 } ] }, { "featureType": "poi.park", "elementType": "geometry.fill", "stylers": [ { "color": "#bce7b7" } ] }, { "featureType": "poi.park", "elementType": "geometry.stroke", "stylers": [ { "color": "#ecf5e7" } ] }, { "featureType": "road.highway", "elementType": "all", "stylers": [ { "visibility": "off" }, { "color": "#ff0000" } ] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [ { "color": "#ffffff" }, { "lightness": 17 } ] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [ { "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 } ] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [ { "color": "#ffffff" }, { "lightness": 18 } ] }, { "featureType": "road.arterial", "elementType": "geometry.fill", "stylers": [ { "color": "#f4dedb" } ] }, { "featureType": "road.arterial", "elementType": "labels.text.fill", "stylers": [ { "color": "#7b808f" } ] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [ { "color": "#ffffff" }, { "lightness": 16 } ] }, { "featureType": "road.local", "elementType": "geometry.fill", "stylers": [ { "color": "#f0f2f5" } ] }, { "featureType": "road.local", "elementType": "geometry.stroke", "stylers": [ { "color": "#ffffff" } ] }, { "featureType": "transit", "elementType": "geometry", "stylers": [ { "color": "#f2f2f2" }, { "lightness": 19 } ] }, { "featureType": "water", "elementType": "geometry", "stylers": [ { "color": "#e9e9e9" }, { "lightness": 17 } ] }, { "featureType": "water", "elementType": "geometry.fill", "stylers": [ { "color": "#9ec2ed" } ] } ]
		element:'#main-map'
	$el:null
	map: null
	moveTimer:null
	markersById:{}
	clusters:{}
	mapData:null
	placeCache:{}

	constructor:(config, mapData=null, currentPlace = null)->
		if config?
			jQuery.extend true, @config, config
		
		@mapData = mapData
		@currentPlace = currentPlace

		@$el = jQuery(@config.element)
		cbName = 'AtlasMapCB'+Math.floor(Math.random()*10000000)
		window[cbName] = @onLoad
		jQuery.getScript('https://maps.googleapis.com/maps/api/js?key='+encodeURIComponent(@config.apiKey)+'&callback='+cbName)
		jQuery('.place-popup-backdrop').on 'click', (e)->
			e.preventDefault()
			jQuery(this).removeClass('active')
			jQuery('.place-popup').fadeOut 'fast', (e)->
				jQuery(this).remove()
				history.replaceState({}, "", "/map")



	onLoad:()=>
		customMapTypeId = 'custom_style'
		customMapType = new google.maps.StyledMapType(@config.mapStyle, name: 'Custom Style')

		mapOptions = 
			zoom: @config.zoom
			center: 
				lat: @config.coord[0]
				lng: @config.coord[1]
			mapTypeControlOptions:
				mapTypeIds: []
		@map = new google.maps.Map @$el.get(0), mapOptions
		@map.mapTypes.set(customMapTypeId, customMapType)
		@map.setMapTypeId(customMapTypeId)
		if @mapData?
			@handleSearch(@mapData)
		if @currentPlace?
			@addMarker(@currentPlace)
			@showPopupWindow(@currentPlace)

		@map.addListener('bounds_changed', @onMove)

	onMove:()=>
		clearTimeout @moveTimer;
		@moveTimer = setTimeout ()=>
			bounds = @map.getBounds()
			southWest = bounds.getSouthWest()
			northEast = bounds.getNorthEast()
			@search southWest.lat(), southWest.lng(), northEast.lat(), northEast.lng(), @handleSearch
			, 300
	handleSearch:(data)=>
		for i in [0...data.length]
			place = data[i]
			@addMarker(place)

	getPopupWindow:(place)=>
		$placePopup = jQuery('<div />').addClass('place-popup')
		$content = jQuery('<div />').addClass('popup-content').appendTo($placePopup)
		jQuery('<a />').addClass('btn-close').html('&times;').appendTo $content
		$favorite = jQuery('<a />').addClass('btn-favorite').html('<span class="glyphicon glyphicon-heart"></span>').appendTo $content

		if !window.user?
			$favorite.addClass('disabled').attr('data-toggle', 'tooltip').attr('data-placement', 'top').attr('title', 'Vous devez être connecté pour ajouter cet emplacement à vos favoris').tooltip()
		else if window.user? && window.user.favoriteIds? && window.user.favoriteIds.indexOf(place.id) >= 0
			$favorite.addClass('on')

		$favorite.on 'click', (e)->
			$this = jQuery(this)
			e.preventDefault()
			data = {
				_token : jQuery('input[name="_token"]').first().val()
			}
			if jQuery(this).is('.on')
				jQuery.post '/favorites/'+place.id+'/remove', data, ()->
					index = window.user.favoriteIds.indexOf(place.id)
					if index >= 0
						window.user.favoriteIds.splice(0, 1)
					$this.removeClass('on')
			else
				jQuery.post '/favorites/'+place.id+'/add', data, ()->
					index = window.user.favoriteIds.indexOf(place.id)
					if index >= 0
						window.user.favoriteIds.splice(0, 1)
					window.user.favoriteIds.push place.id
					$this.addClass('on')

		if place.date1? && place.date1.length && place.date1.length > 0
			date = place.date1
			if place.date2? && place.date2.length && place.date2.length > 0
				date += ' - '+place.date2
			$content.append jQuery('<h3 />').addClass('place-date').text(date)
		description = place.short_description
		
		$content.append jQuery('<h2 />').text(place.name)
		$content.append jQuery('<h4 />').addClass('place-address').text(place.address)
		$content.append jQuery('<p />').addClass('place-description').text(description)

		if window.user?
			$content.append(jQuery('<a />').addClass('btn btn-primary').text('Lire / Éditer').attr('data-id', place.id).attr('href', '/places/'+place.id).attr('target', '_blank'))
			if window.user? && window.user.role_id? && window.user.role_id == 1
				$content.append(jQuery('<a />').addClass('btn btn-primary').text('Admin').attr('data-id', place.id).attr('href', '/admin/places/'+place.id+'/edit/').attr('target', '_blank'))

		$placePopup.append(jQuery('<div />').addClass('streetview'))
			
		return $placePopup.get(0)


	computeAngle:(endLatLng, startLatLng)=>
		DEGREE_PER_RADIAN = 57.2957795
		RADIAN_PER_DEGREE = 0.017453

		dlat = endLatLng.lat() - startLatLng.lat()
		dlng = endLatLng.lng() - startLatLng.lng()
		yaw = Math.atan2(dlng * Math.cos(endLatLng.lat() * RADIAN_PER_DEGREE), dlat) * DEGREE_PER_RADIAN
		return @wrapAngle(yaw)

	wrapAngle:(angle)=>
		if angle >= 360
			angle -= 360;
		else if angle < 0
			angle += 360;

		return angle;

	showPopupWindow:(place)=>
		url = "/map/"+place.id
		history.pushState(place, place.name, url)
		@map.panTo({lat: place.latitude, lng: place.longitude});

		$popup = jQuery(@getPopupWindow place)
		jQuery('body').find('.place-popup').remove()
		$popup.hide()
		jQuery('body').append $popup
		jQuery('.place-popup-backdrop').addClass('active')
		$popup.find('a.btn-close').on 'click', (e)->
			e.preventDefault()
			jQuery('.place-popup-backdrop').removeClass('active')
			history.replaceState({}, "", "/map")
			$popup.fadeOut 'fast', (e)->
				jQuery(this).remove()

		addLatLng = new google.maps.LatLng(place.latitude, place.longitude);

		service = new google.maps.StreetViewService();
		panoRequest = {
        location: addLatLng,
        preference: google.maps.StreetViewPreference.NEAREST,
        radius: 50,
        source: google.maps.StreetViewSource.OUTDOOR
    }
		
		service.getPanorama panoRequest, (panoData, status)=>
			angle = null
			console.log 'Pano Data!!!!', panoData
			if panoData? && panoData.location?
				angle = @computeAngle(addLatLng, panoData.location.latLng);
				options = 
					source: 'outdoor'
					position: 
						lat: panoData.location.latLng.lat()
						lng: panoData.location.latLng.lng() 
					linksControl: false
					panControl: false
					enableCloseButton: false
					zoomControl: false
					addressControl:false
					pov:
						heading: angle,
						pitch: 10,
						source: 'outdoor'
						zoom: 1
			$popup.fadeIn 'fast'
			if angle?
				$popup.addClass 'has-panorama'
				panorama = new google.maps.StreetViewPanorama($popup.find('.streetview').get(0), options)
			else
				$popup.removeClass 'has-panorama'

	addMarker:(place)=>
		if !@markersById[place.id]?
			latLng = 
					lat: place.latitude
					lng: place.longitude

			markerIconOptions = 
				'marker-color': '1c0750'

			markerIconOptions['marker-color'] = if place.is_virtual then '7b133b' else '1c0750'

			if window._currentPlace? && window._currentPlace.id? && window._currentPlace.id == place.id
				markerIconOptions['marker-size'] = 'large'
			
			if place.mapbox_icon? && false
				markerIconOptions['marker-symbol'] = place.mapbox_icon
			else
				markerIconOptions['marker-symbol'] = 'marker'



			marker = new google.maps.Marker
				position: latLng
				# map: @map
				title: place.name
				icon: (window.location+'').split('/').slice(0,3).join('/')+'/images/map_icons/'+markerIconOptions['marker-symbol']+'-12@2x.png'

			$placePopup = jQuery('<div />').addClass('place-popup')
			$content = jQuery('<div />').addClass('popup-content').appendTo($placePopup)
			if place.date1? && place.date1.length && place.date1.length > 0
				date = place.date1
				if place.date2? && place.date2.length && place.date2.length > 0
					date += ' - '+place.date2
				$content.append jQuery('<h3 />').addClass('place-date').text(date)

			$content.append jQuery('<h2 />').text(place.name)
			$content.append jQuery('<p />').addClass('place-description').text(place.description)
			if window.user?
				$content.append(jQuery('<a />').addClass('btn btn-primary').text('Lire / Éditer').attr('data-id', place.id).attr('href', '/atlas/map/'+place.id))
				if window.user? && window.user.role_id? && window.user.role_id == 1
					$content.append(jQuery('<a />').addClass('btn btn-primary').text('Admin').attr('data-id', place.id).attr('href', '/admin/places/'+place.id+'/edit/').attr('target', '_blank'))
			$placePopup.append(jQuery('<div />').addClass('streetview'))

			$content.find('a').on 'click', (e)->
				e.preventDefault();
				jQuery.getJSON jQuery(this).attr('href')+'.json', (data)->
					console.log 'Data!', data
					Templates.load data.assets.template, data, (html)->
						jQuery('body >.container >.content >.inner').html(html).parent().slideDown 'fast'
				 	console.log jQuery(".leaflet-popup-close-button").click();

			infoWindow = new google.maps.InfoWindow
				content: '<div class="place-popup">'+$placePopup.html()+'</div>'
			marker.addListener 'click', (e)=>
				for key of @markersById
					@markersById[key].infoWindow.close()
					
				# infoWindow.open(@map, marker);
				@$el.addClass('loading')
				@getPlaceData place.id, (_place)=>
					@$el.removeClass('loading')

					@showPopupWindow _place

			clusterType = if place.is_real && place.is_virtual then 'both' else if place.is_real then 'real' else 'fiction'
			@addMarkerToCluster marker, clusterType
			@markersById[place.id] = 
				marker: marker
				infoWindow: infoWindow
				place: place
			
			marker.addListener 'mouseover', (e)=>
				jQuery('body').attr('data-active-tooltip', place.id)
				@getPlaceData place.id, (_place)=>
					@showTooltip _place, marker
			marker.addListener 'mouseout', (e)=>
				jQuery('body').removeAttr('data-active-tooltip').find('.place-tooltip').remove()

		return @markersById[place.id]


	fromLatLngToPoint:(latLng)=>
		topRight = @map.getProjection().fromLatLngToPoint(@map.getBounds().getNorthEast())
		bottomLeft = @map.getProjection().fromLatLngToPoint(@map.getBounds().getSouthWest())
		scale = Math.pow(2, @map.getZoom())
		worldPoint = @map.getProjection().fromLatLngToPoint(latLng)
		new google.maps.Point((worldPoint.x - bottomLeft.x) * scale, (worldPoint.y - topRight.y) * scale)

	showTooltip:(place, marker)=>
		jQuery('body').find('.place-tooltip').not('[data-id="' + place.id + '"]').remove()
		point = @fromLatLngToPoint(marker.getPosition())

		$popup = jQuery('<div />').addClass('place-tooltip').attr('data-id', place.id)
		$popup.appendTo('body')
		$popup.text(place.name)
		$popup.css {
			left: point.x
			top: point.y
		}


	search:(lat,lng,lat2,lng2, cb)=>
		exclude = []
		for id of @markersById
			exclude.push id
		postData = 
			exclude: exclude.join(',')
		jQuery.post '/api/search/'+lat+'/'+lng+'/'+lat2+'/'+lng2+'.json', postData, (data)->
			if cb?
				cb data

	getPlaceData:(id, cb)=>
		if @placeCache[id]?
			cb(@placeCache[id])
			return
		jQuery.getJSON '/api/place/'+id+'.json', (data)=>
			@placeCache[id] = data
			cb(data)

	addMarkerToCluster:(marker, clusterType)=>
		if !@clusters? || !@clusters[clusterType]?
			options=
				imagePath:'/images/cluster/'+clusterType
			@clusters[clusterType] = new MarkerClusterer(@map, [], options);
		@clusters[clusterType].addMarker marker

		
window.AtlasMap = Map